import styled from 'styled-components';

const IndexStyled = styled.div`
  height: 100%;
  .single_component1 {
    margin-bottom: 0;
  }
  .single_component2 {
    margin-bottom: 24px;
  }
  .single_component {
    border-radius: 12px;
    /* border: 1px solid red; */
    background-color: #fff;
    margin-top: 24px;
    flex-grow: 1;
  }
  .create_button {
    margin: 24px 0;
    padding-left: 32px;
    display: flex;
    gap: 0 32px;
    .createBtn {
      /* width: 107px; */
      height: 34px;
      background: #1565c0;
      border-radius: 24px;
      font-size: 13px;
    }
  }
  .action_btn_group {
    margin-right: 1rem;
    display: flex;
    > div {
      margin-right: 10px;
    }
  }
  .crowd_content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .contentMsg {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .editDetail {
    display: flex;
    justify-content: center;

    > div {
      margin-right: 20px;
    }
  }
`;

export default IndexStyled;
